import PromoModalItem from "./PromoModalItem";
import PromoModalOffer from "./PromoModalOffer";
import PromoModalTitle from "./PromoModalTitle";

export {
    PromoModalItem,
    PromoModalOffer,
    PromoModalTitle,
};



// WEBPACK FOOTER //
// src/client/components/site/features/promos/elements/index.js